import { local_storage, LOCALSTORAGE_OPTIONS, localStorageKey } from '@/store/lib/local_storage';

function sidebarPrefsFromStorage(key, key_legacy, prefs_default) {
  const prefs_storage = key ? local_storage.get(key) : {};
  if (!_.isEmpty(prefs_storage) || !key_legacy) {
    return { ...prefs_default, ...prefs_storage };
  }

  const prefs_legacy = local_storage.get(key_legacy);
  return { ...prefs_default, ...prefs_legacy };
}

const state = {
  sidebar_prefs: {
    page: 1,
    is_pinned: false,
    sidebar_width: 450,
  },
  sidebar_type: null,
  project_sidebar_prefs: {
    is_pinned: false,
    sidebar_width: 300,
  },
  project_sidebar_visible: false,
};

const actions = {
  INIT_SIDEBAR_PREFS({ commit, getters }) {
    const key = getters.local_storage_key;
    const key_legacy = getters.local_storage_key_legacy;
    const default_sidebar_prefs = getters.sidebar_prefs;
    if (!key) {
      // e.g. necessary when employee impersonates a customer
      commit('SET_SIDEBAR_PREFS', default_sidebar_prefs);
    } else {
      const sidebar_prefs = sidebarPrefsFromStorage(key, key_legacy, default_sidebar_prefs);
      commit('SET_SIDEBAR_PREFS', sidebar_prefs);
      local_storage.set(key, sidebar_prefs);
    }
  },

  UPDATE_SIDEBAR_PREFS({ commit, getters }, sidebar_prefs) {
    const attributes = { ...getters.sidebar_prefs, ...sidebar_prefs };
    commit('SET_SIDEBAR_PREFS', attributes);
    if (getters.local_storage_key) local_storage.set(getters.local_storage_key, getters.sidebar_prefs);
  },

  SHOW_SIDEBAR({ commit }, type) {
    commit('SET_SIDEBAR_TYPE', type);
  },

  INIT_PROJECT_SIDEBAR_PREFS({ commit, getters }) {
    const key = getters.project_sidebar_local_storage_key;
    const defaults = getters.project_sidebar_prefs;
    if (!key) {
      commit('SET_PROJECT_SIDEBAR_PREFS', defaults);
    } else {
      const prefs = { ...defaults, ...local_storage.get(key) };
      commit('SET_PROJECT_SIDEBAR_PREFS', prefs);
      local_storage.set(key, prefs);
    }
  },

  UPDATE_PROJECT_SIDEBAR_PREFS({ commit, getters }, prefs) {
    const attributes = { ...getters.project_sidebar_prefs, ...prefs };
    commit('SET_PROJECT_SIDEBAR_PREFS', attributes);
    if (getters.project_sidebar_local_storage_key) {
      local_storage.set(getters.project_sidebar_local_storage_key, getters.project_sidebar_prefs);
    }
  },

  SHOW_PROJECT_SIDEBAR({ commit }, visible) {
    commit('SET_PROJECT_SIDEBAR_VISIBLE', visible);
  },
};

const mutations = {
  SET_SIDEBAR_PREFS(state, sidebar_prefs) {
    state.sidebar_prefs = sidebar_prefs;
  },

  SET_SIDEBAR_TYPE(state, type) {
    state.sidebar_type = type;
  },

  SET_PROJECT_SIDEBAR_PREFS(state, prefs) {
    state.project_sidebar_prefs = prefs;
  },

  SET_PROJECT_SIDEBAR_VISIBLE(state, visible) {
    state.project_sidebar_visible = visible;
  },
};

const getters = {
  sidebar_prefs: (state) => state.sidebar_prefs,
  sidebar_type: (state) => state.sidebar_type,
  local_storage_key: (_state, _getters, rootState) => {
    const { current_profile } = rootState.shared.current;
    return localStorageKey(current_profile, LOCALSTORAGE_OPTIONS.NOTIFICATIONS_SIDEBAR);
  },
  local_storage_key_legacy: (_state, _getters, rootState) => {
    const { current_profile } = rootState.shared.current;
    return localStorageKey(current_profile, LOCALSTORAGE_OPTIONS.SIDEBAR);
  },
  project_sidebar_prefs: (state) => state.project_sidebar_prefs,
  project_sidebar_visible: (state) => state.project_sidebar_visible,
  project_sidebar_local_storage_key: (_state, _getters, rootState) => {
    const { current_profile } = rootState.shared.current;
    return localStorageKey(current_profile, LOCALSTORAGE_OPTIONS.PROJECT_SIDEBAR);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
